(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const titles = new Map();
  let frameId = null;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const smoothstep = (value) => value * value * (3 - 2 * value);

  const register = (root = document) => {
    const candidates = root.matches?.('[data-sp-motion-title]')
      ? [root]
      : [...root.querySelectorAll('[data-sp-motion-title]')];

    candidates.forEach((title) => {
      if (titles.has(title)) return;

      const section = title.closest('[data-sp-motion-section]') || title.parentElement;
      const start = window.innerWidth * 0.65;
      titles.set(title, { section, current: start, target: start });
      title.style.setProperty('--sp-motion-title-x', `${start.toFixed(2)}px`);
    });

    requestUpdate();
  };

  const update = () => {
    const viewportHeight = window.innerHeight;
    const startDistance = window.innerWidth * 0.65;
    let keepAnimating = false;

    titles.forEach((state, title) => {
      if (!title.isConnected || !state.section?.isConnected) {
        titles.delete(title);
        return;
      }

      const bounds = state.section.getBoundingClientRect();
      const progress = clamp((viewportHeight * 0.92 - bounds.top) / (viewportHeight * 0.9), 0, 1);
      state.target = Math.max(0, startDistance * (1 - smoothstep(progress)));
      state.current += (state.target - state.current) * 0.12;

      if (Math.abs(state.target - state.current) < 0.08) {
        state.current = state.target;
      } else {
        keepAnimating = true;
      }

      title.style.setProperty('--sp-motion-title-x', `${Math.max(0, state.current).toFixed(2)}px`);
    });

    frameId = keepAnimating ? window.requestAnimationFrame(update) : null;
  };

  function requestUpdate() {
    if (reduceMotion.matches || frameId !== null) return;
    frameId = window.requestAnimationFrame(update);
  }

  if (reduceMotion.matches) {
    document.querySelectorAll('[data-sp-motion-title]').forEach((title) => {
      title.style.setProperty('--sp-motion-title-x', '0px');
    });
    return;
  }

  register();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', requestUpdate);
})();
